import styled from "styled-components"

import { colors, spacing } from "@izettle/otto"
import { Button as ZButton, ButtonProps } from "@izettle/react"

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${spacing.medium};
`

export const TabButton = styled(ZButton).attrs({ variant: "inline" })<ButtonProps>`
  font-size: 16px !important;
  margin: 0;
  padding: ${spacing.small} 0 !important;
  min-height: auto !important;
  text-decoration-line: none !important;

  span {
    justify-content: start;
    color: ${colors.text.default} !important;
  }

  ${({ size }) =>
    size === "small"
      ? `
    font-size: 14px!important;
  `
      : ""};
`
